//#region src/kiosk_bluetooth_state.ts
var KioskBluetoothState = /* @__PURE__ */ function(KioskBluetoothState) {
	KioskBluetoothState[KioskBluetoothState["Unknown"] = 0] = "Unknown";
	KioskBluetoothState[KioskBluetoothState["Resetting"] = 1] = "Resetting";
	KioskBluetoothState[KioskBluetoothState["Unsupported"] = 2] = "Unsupported";
	KioskBluetoothState[KioskBluetoothState["Unauthorized"] = 3] = "Unauthorized";
	KioskBluetoothState[KioskBluetoothState["PoweredOff"] = 4] = "PoweredOff";
	KioskBluetoothState[KioskBluetoothState["PoweredOn"] = 5] = "PoweredOn";
	return KioskBluetoothState;
}(KioskBluetoothState || {});
//#endregion
export { KioskBluetoothState };

//# sourceMappingURL=kiosk_bluetooth_state.js.map